<!--系统管理页面弹窗组件  :rules="rules"-->
<template>
  <el-dialog title="添加人员信息" :visible="show" width="80%" @close="closeWindow" class="dialog_container">

    <div class="name-per">
      <div v-for="(item,index) in titleList" :key='index' class="name-list" @click="changeIdx(item.id)">
        <div>
          <div class="name-title" :class="{changeColor:tapId==item.id}">
            <div></div>
            <div><i class="el-icon-circle-check"></i></div>
            <div></div>
          </div>
          <div class="name-bottom">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <div v-show="tapId == 1">
      <div class="tap1-title1">
        <div>
          <div class="tap1-left1">
            <div>姓名：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>出生年月：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>民族：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>家庭号码：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>性别：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>年龄：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
        <div>
          <div class="tap1-left1">
            <div>婚姻状况：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>用户类型：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>身份证号：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>手机号码：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>生活区域：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>区域名称：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>

        </div>
        <div>
          <div class="upload-demo">
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload1">
              <img v-if="formData.imageUrl1" :src="formData.imageUrl1" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </div>

      <div class="tap1-left2">
        <div>居住情况：</div>
        <div>
          <el-select v-model="formData.juzu" placeholder="请选择" size="medium" style="width: 100%;">
            <el-option label="独自居住" value="1"></el-option>
            <el-option label="与配偶居住" value="2"></el-option>
            <el-option label="与子女居住" value="3"></el-option>
            <el-option label="其他" value="4"></el-option>
          </el-select>
        </div>
      </div>

      <div class="tap1-left2">
        <div>经济来源：</div>
        <div>
          <el-checkbox-group v-model="formData.selfCare">
            <el-checkbox label="1">养老金</el-checkbox>
            <el-checkbox label="2">子女供养</el-checkbox>
            <el-checkbox label="3">救济优抚</el-checkbox>
            <el-checkbox label="4">兼职</el-checkbox>
            <el-checkbox label="5">其他</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="tap1-left2">
        <div>个人喜好：</div>
        <div>
          <el-checkbox-group v-model="formData.xihao">
            <el-checkbox label="1">棋牌</el-checkbox>
            <el-checkbox label="2">舞蹈</el-checkbox>
            <el-checkbox label="3">诗词</el-checkbox>
            <el-checkbox label="4">戏曲</el-checkbox>
            <el-checkbox label="5">钓鱼</el-checkbox>
            <el-checkbox label="6">书画</el-checkbox>
            <el-checkbox label="7">收藏</el-checkbox>
            <el-checkbox label="8">摄影</el-checkbox>
            <el-checkbox label="9">旅游</el-checkbox>
            <el-checkbox label="10">唱歌</el-checkbox>
            <el-checkbox label="11">其他</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="tap1-left2">
        <div>地址：</div>
        <div>
          <el-select v-model="formData.shengId" placeholder="请选择省" @change="handleProvince" ref="selectShengChange">
            <el-option v-for="(item, index) in provinceList" :key="index" :label="item.name" :value="item.adcode">
            </el-option>
          </el-select>
          <el-select v-model="formData.shiId" placeholder="请选择市" @change="handleCity" ref="selectShiChange">
            <el-option v-for="(item, index) in cityList" :key="index" :label="item.name" :value="item.adcode">
            </el-option>
          </el-select>
          <el-select v-model="formData.quId" placeholder="请选择区" @change="handleArea" ref="selectQuChange">
            <el-option v-for="(item, index) in areaList" :key="index" :label="item.name" :value="item.adcode + index">
            </el-option>
          </el-select>
          <el-select v-model="formData.jiedaoId" placeholder="请选择街道" @change="streetChange" ref="selectJiedaoChange">
            <el-option v-for="(item, index) in streetList" :key="index" :label="item.name" :value="item.adcode + index">
            </el-option>
          </el-select>
          <el-select v-model="formData.shequId" placeholder="请选择社区" ref="selectShequChange"
                     @change="handleCommunityChange">
            <el-option v-for="item in communityList" :key="item.id" :label="item.addressName" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="tap1-left2">
        <div>详细地址：</div>
        <div>
          <el-input size="medium"></el-input>
        </div>
      </div>

      <div class="tap1-left2">
        <div>居住地址：</div>
        <div>
          <el-input size="medium"></el-input>
        </div>
      </div>

      <div class="tap1-left2">
        <div>附加信息：</div>
        <div>
          <el-input size="medium"></el-input>
        </div>
      </div>

      <div class="tap1-left2">
        <div>老人类别：</div>
        <div>
          <el-checkbox-group v-model="formData.leibie">
            <el-checkbox label="1">特困老人</el-checkbox>
            <el-checkbox label="2">低保老人</el-checkbox>
            <el-checkbox label="3">建档立卡贫困老人</el-checkbox>
            <el-checkbox label="4">优抚对象</el-checkbox>
            <el-checkbox label="5">失独老人</el-checkbox>
            <el-checkbox label="6">残疾老人</el-checkbox>
            <el-checkbox label="7">计划生育特殊家庭成员</el-checkbox>
            <el-checkbox label="8">空巢老人</el-checkbox>
            <el-checkbox label="9">农村留守老人</el-checkbox>
            <el-checkbox label="10">其他</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="tap1-left2">
        <div>政府购买对象：</div>
        <div>
          <el-checkbox-group v-model="formData.duixiang">
            <el-checkbox label="1">70岁以上享受城乡低保待遇</el-checkbox>
            <el-checkbox label="2">80岁以上重点优抚对象</el-checkbox>
            <el-checkbox label="3">80岁以上失独老人</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="tap1-left2">
        <div>是否为政府购买对象：</div>
        <div>
          <el-radio-group v-model="formData.radio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="tap1-left2">
        <div>期望养老模式：</div>
        <div>
          <el-checkbox-group v-model="formData.yanglao">
            <el-checkbox label="1">居家养老</el-checkbox>
            <el-checkbox label="2">社区养老</el-checkbox>
            <el-checkbox label="3">机构养老</el-checkbox>
            <el-checkbox label="4">其他</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="tap1-left2">
        <div>期望的服务：</div>
        <div>
          <el-checkbox-group v-model="formData.fuwu">
            <el-checkbox label="1">家政服务</el-checkbox>
            <el-checkbox label="2">生活照料</el-checkbox>
            <el-checkbox label="3">健康咨询</el-checkbox>
            <el-checkbox label="4">精神慰藉</el-checkbox>
            <el-checkbox label="5">陪同就医</el-checkbox>
            <el-checkbox label="6">换季服务</el-checkbox>
            <el-checkbox label="7">助浴服务</el-checkbox>
            <el-checkbox label="8">助残服务</el-checkbox>
            <el-checkbox label="9">助洁服务</el-checkbox>
            <el-checkbox label="10">助餐服务</el-checkbox>
            <el-checkbox label="11">助行服务</el-checkbox>
            <el-checkbox label="12">定制服务</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <el-divider></el-divider>

      <div class="tap1-jianhuan">
        <div></div>
        <div>监护人或紧急联系人信息</div>
      </div>

      <div class="tap1-lianxi">
        <div>
          <div class="upload-demo">
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
              <img v-if="formData.imageUrl2" :src="formData.imageUrl2" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
        <div>
          <div class="tap1-left1">
            <div>志愿者：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>志愿者电话：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="tap1-lianxi">
        <div>
          <div class="upload-demo">
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
              <img v-if="formData.imageUrl2" :src="formData.imageUrl2" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
        <div>
          <div class="tap1-left1">
            <div>志愿者：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>志愿者电话：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="tap1-lianxi">
        <div>
          <div class="upload-demo">
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
              <img v-if="formData.imageUrl2" :src="formData.imageUrl2" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
        <div>
          <div class="tap1-left1">
            <div>志愿者：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>志愿者电话：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="tap1-jianhuan">
        <div></div>
        <div>配偶紧急联系人</div>
      </div>

      <div class="tap1-lianxi">
        <div>
          <div class="upload-demo">
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
              <img v-if="formData.imageUrl2" :src="formData.imageUrl2" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
        <div>
          <div class="tap1-left1">
            <div>姓名：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>关系：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>性别：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>年龄：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>民族：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="tap1-jianhuan">
        <div></div>
        <div>直系亲属紧急联系人</div>
      </div>

      <div class="tap1-lianxi">
        <div>
          <div class="upload-demo">
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
              <img v-if="formData.imageUrl2" :src="formData.imageUrl2" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
        <div>
          <div class="tap1-left1">
            <div>姓名：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>关系：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>性别：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>联系电话：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>备用电话：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="tap1-left2">
        <div>联系地址：</div>
        <div>
          <el-input size="medium"></el-input>
        </div>
      </div>

      <div class="tap1-jianhuan">
        <div></div>
        <div>紧急联系人</div>
      </div>

      <div class="tap1-lianxi">
        <div>
          <div class="upload-demo">
            <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2">
              <img v-if="formData.imageUrl2" :src="formData.imageUrl2" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
        <div>
          <div class="tap1-left1">
            <div>姓名：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>关系：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>性别：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>联系电话：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left1">
            <div>备用电话：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="tap1-left2">
        <div>联系地址：</div>
        <div>
          <el-input size="medium"></el-input>
        </div>
      </div>
      <div class="tap1-jianhuan">
        <div></div>
        <div>操作历史记录</div>
      </div>

      <div class="tap1-bottom">
        <div>
          <div class="tap1-left3">
            <div>登记时间：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>签约时间：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>注销时间：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>信息取消时间：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
        <div>
          <div class="tap1-left3">
            <div>登记人：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>签约人：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>注销人：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>实体取消时间：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-show="tapId == 2">
      <div class="tap1-left2">
        <div>病史：</div>
        <div>
          <el-checkbox-group v-model="formData.bingshi">
            <el-checkbox label="1">健康</el-checkbox>
            <el-checkbox label="2">高血压</el-checkbox>
            <el-checkbox label="3">糖尿病</el-checkbox>
            <el-checkbox label="4">冠心病</el-checkbox>
            <el-checkbox label="5">恶性肿瘤</el-checkbox>
            <el-checkbox label="6">结核病</el-checkbox>
            <el-checkbox label="7">肝癌</el-checkbox>
            <el-checkbox label="8">脑卒中</el-checkbox>
            <el-checkbox label="9">精神病史</el-checkbox>
            <el-checkbox label="10">慢性阻塞性肺疾病</el-checkbox>
            <el-checkbox label="11">帕金森综合症</el-checkbox>
            <el-checkbox label="12">腰间盘突出</el-checkbox>
            <el-checkbox label="13">阿尔茨海默病</el-checkbox>
            <el-checkbox label="14">心脏病</el-checkbox>
            <el-checkbox label="15">肺气肿</el-checkbox>
            <el-checkbox label="16">白内障</el-checkbox>
            <el-checkbox label="17">脑血栓</el-checkbox>
            <el-checkbox label="18">风湿病</el-checkbox>
            <el-checkbox label="19">脑中风</el-checkbox>
            <el-checkbox label="20">高脂血压</el-checkbox>
            <el-checkbox label="21">哮喘</el-checkbox>
            <el-checkbox label="22">意外伤害</el-checkbox>
            <el-checkbox label="23">其他</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="tap1-left2">
        <div>自理类别：</div>
        <div>
          <el-checkbox-group v-model="formData.zili">
            <el-checkbox label="1">自理</el-checkbox>
            <el-checkbox label="2">失能</el-checkbox>
            <el-checkbox label="3">半失能</el-checkbox>
            <el-checkbox label="4">轻度依赖</el-checkbox>
            <el-checkbox label="5">重度依赖</el-checkbox>
            <el-checkbox label="6">不能自理</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="tap1-left2">
        <div>听力状况：</div>
        <div>
          <el-radio-group v-model="formData.radio">
            <el-radio :label="1">良好</el-radio>
            <el-radio :label="2">一般</el-radio>
            <el-radio :label="3">很大声才能听见</el-radio>
            <el-radio :label="4">听不见</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="tap1-jianhuan">
        <div></div>
        <div>健康记录</div>
      </div>
      <div>
        <el-table :data="healthyList" border style="width: 100%"
                  :header-cell-style="{ background: '#f2f2f2', color: '#000' }">
          <el-table-column prop="name1" label="心率" align="center" width="150" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="name2" label="血压低压" align="center" width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="name3" label="血压高压" align="center" width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="name4" label="血糖" align="center" width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="name4" label="上传时间" align="center" width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="name4" label="数据来源" align="center" :show-overflow-tooltip="true">
          </el-table-column>
        </el-table>
      </div>

    </div>
    <div v-show="tapId == 3">
      <div class="tap1-jianhuan">
        <div></div>
        <div>享受的服务信息</div>
      </div>

      <div class="tap1-bottom">
        <div>
          <div class="tap1-left3">
            <div>服务类别：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>服务状态：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>用户手机套餐：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>用户手机型号：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
        <div>
          <div class="tap1-left3">
            <div>用户享受的服务类别：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>政府援助次数：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>状态变更原因：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
          <div class="tap1-left3">
            <div>审核拒绝原因：</div>
            <div>
              <el-input size="medium"></el-input>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div v-show="tapId == 4">
      <el-table :data="replyList" border style="width: 100%"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }">
        <el-table-column prop="name1" label="时间" align="center" width="150" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="name2" label="回复类型" align="center" width="180" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="name3" label="回访需求" align="center" width="180" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="name4" label="通话记录" align="center" width="180" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="name4" label="回访流程" align="center" width="180" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="name4" label="数据来源" align="center" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </div>
    <div v-show="tapId == 5"></div>
    <div v-show="tapId == 6"></div>
    <div v-show="tapId == 7"></div>

    <div class="btn">
      <div>
        <el-button type="primary" @click="send">保存</el-button>
        <el-button @click="closeWindow">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import request from "@/utils/request.js"

export default {
  name: 'AddCustomer',
  props: {
    showCustomer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      titleList: [{
        id: '1',
        name: '老人基本信息'
      },
        {
          id: '2',
          name: '健康信息'
        },
        {
          id: '3',
          name: '政府援助信息'
        },
        {
          id: '4',
          name: '历史回复'
        },
        {
          id: '5',
          name: '客户电子账户'
        },
        {
          id: '6',
          name: '兴康管家信息'
        },
        {
          id: '7',
          name: '客户地理位置'
        }
      ],
      tapId: '1',
      healthyList: [],
      replyList: [],
      formData: {
        selfCare: [],
        xihao: [],
        leibie: [],
        duixiang: [],
        yanglao: [],
        fuwu: [],
        bingshi: [],
        zili: []
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      communityList: []
    }
  },
  computed: {
    show() {
      return this.showCustomer
    }
  },
  created() {

  },
  methods: {
    changeIdx(id) {
      this.tapId = id
    },
    handleAvatarSuccess1(res, file) {
      this.formData.imageUrl1 = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload1(file) {

    },
    handleAvatarSuccess2(res, file) {
      this.formData.imageUrl2 = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload2(file) {

    },
    handleProvince(val) {

    },
    handleCity(val) {

    },
    handleArea(val) {

    },
    streetChange(val) {

    },
    handleCommunityChange(val) {

    },
    send() {
      this.closeWindow()
    },

    closeWindow() {
      this.$emit('update:showCustomer', false)
    }
  }
}
</script>
<style lang="less" scoped>
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.name-per {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 20px;
}

.name-list {
  width: 14.27%;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.name-list > div:first-child {
  width: 100%;
}

.name-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.name-title > div:first-child {
  width: 50%;
  height: 2px;
  background-color: #EEEEEE;
}

.name-title > div:last-child {
  width: 50%;
  height: 2px;
  background-color: #EEEEEE;
}

.changeColor > div:first-child {
  background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
  color: #0000ff;
}

.changeColor > div:last-child {
  background-color: #0000ff;
}

.name-bottom {
  width: 100%;
  text-align: center;
}

.tap1-title1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tap1-title1 > div {
  width: 33%;
}

.tap1-left1 {
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.tap1-left1 > div:first-child {
  width: 100px;
  text-align: right;
}

.tap1-left1 > div:nth-child(2) {
  width: calc(100% - 100px);
}

.tap1-left2 {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}

.tap1-left2 > div:first-child {
  width: 100px;
  text-align: right;
}

.tap1-left2 > div:nth-child(2) {
  width: calc(100% - 100px);
}

.tap1-jianhuan {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  display: flex;
  color: #0066CC;
  margin-bottom: 20px;
}

.tap1-jianhuan > div:first-child {
  width: 4px;
  background-color: #0066CC;
  margin-right: 4px;
}

.tap1-lianxi {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.tap1-lianxi > div:first-child {
  width: 35%;
}

.tap1-lianxi > div:nth-child(2) {
  width: 65%;
}

.tap1-bottom {
  width: 100%;
  display: flex;
}

.tap1-bottom > div {
  width: 50%;
}

.tap1-left3 {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.tap1-left3 > div:first-child {
  width: 120px;
  text-align: right;
}

.tap1-left3 > div:nth-child(2) {
  width: calc(100% - 120px);
}

.upload-demo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>


<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}

.avatar {
  width: 128px;
  height: 128px;
  display: block;
}
</style>
